import axios from "axios";
import { Cookies } from "react-cookie";
import _get from "lodash.get";
import {
  DomainAPI,
  Channel,
  APIKey,
  generateKey,
  Token,
  Authorization,
} from "./setting";
const cookie = new Cookies();
const http = axios.create({
  headers: {
    "Content-type": "application/json;charset=UTF-8",
  },
});

http.interceptors.request.use(
  async (config) => {
    config.headers[APIKey] = generateKey();
    config.headers[Authorization] = cookie.get(Token);
    config.baseURL = DomainAPI + Channel + "/api/secure";
    return config;
  },
  (error) => {
    console.log(error);
    return {
      code: 0,
      error: error,
      data: null,
      message: null,
      type: null,
    };
  }
);

http.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    console.log(error);
    return {
      code: 0,
      error: error,
      data: null,
      message: null,
      type: null,
    };
  }
);

export default http;
